var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaddleinline = function SvgPaddleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    y: 0.564,
    fill: "#16181D",
    rx: 3.26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.74 6.79v.367a1.71 1.71 0 0 1 1.575 1.051c.085.207.13.428.13.651h.34c0-.45.18-.883.5-1.201s.753-.498 1.205-.498v-.368a1.71 1.71 0 0 1-1.576-1.05 1.7 1.7 0 0 1-.129-.652h-.34c-.001.45-.18.883-.5 1.202s-.754.497-1.206.498m4.636-2.338H5.444V3.364h2.932c2.06 0 3.683 1.619 3.683 3.603s-1.623 3.603-3.683 3.603H6.672v3.194H5.444V9.483h2.932c1.433 0 2.456-1.019 2.456-2.515 0-1.495-1.023-2.515-2.456-2.515",
    clipRule: "evenodd"
  })));
};
export default SvgPaddleinline;